import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class DeletedApi {
  getDeletedUsers(config) {
    return axios.get(BASE_URL + "/admin/deleted/deleted-user", config)
  }
  getAllDeletedGab(config){
    return axios.get(BASE_URL + "/admin/deleted/deleted-gab", config)
  }
  getAllDeletedComment(config) {
    return axios.get(BASE_URL + "/admin/deleted/deleted-comment", config)
  }
  
  
  
}

const deletedApi = new DeletedApi()
export default deletedApi
